import { Component, Input, Output, AfterContentInit, ViewChild, forwardRef, ElementRef, EventEmitter  } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { OrganizationService } from '../_services/generatedServices';
import { AuthenticationService } from '../_services/authentication.service';
import { ClientStatus, UserProfileViewModel } from '../_models/generatedModels';
import { dynamicSort } from '../_helpers/extensions.module';


@Component({
    selector: 'coaches-dropdown',
    host: {
        '[class.rundnaDropdown]': 'someAttr',
    },
    template: `
    <kendo-combobox #combo [data]="coachData" [disabled]="isDisabled" [valuePrimitive]="true" [filterable]="true" [popupSettings]="{popupClass: 'df-list-scroller'}" valueField="id" textField="fullName" [(ngModel)]="selectedValue" class="{{cssClass}}" (filterChange)="handleFilter($event)" (valueChange)="onChange($event)">

    </kendo-combobox>
  `,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CoachDropdownControl),
            multi: true
        }
    ]
})

export class CoachDropdownControl implements ControlValueAccessor, AfterContentInit {

    someAttr: string = 'anyValue';

    constructor(elementRef: ElementRef, private orgService: OrganizationService, private auth: AuthenticationService) {
        this.cssClass = elementRef.nativeElement.getAttribute('class');
        elementRef.nativeElement.setAttribute('class', '');
    }

    @Input()
    selectedValue: number;

    @Input()
    isDisabled: boolean;

    @Output()
    changed = new EventEmitter<string>();

    coachData: UserProfileViewModel[] = [];
    coaches: UserProfileViewModel[] = [];
    @ViewChild('combo') public combo: ComboBoxComponent | undefined;
    cssClass: string = '';

    propagateChange = (_: any) => { };
    propagateTouch = () => { };

    writeValue(value: number): void {
        this.selectedValue = value;
    }

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.propagateTouch = fn;
    }

    onChange(value: any) {
        this.writeValue(value);
        this.propagateChange(this.selectedValue);
        this.propagateTouch();
        this.changed.emit(value);
    }

    setDisabledState(isDisabled: boolean): void {
        this.isDisabled = isDisabled;
    }

    ngAfterContentInit(): void {
      this.orgService.getOrgUsers().subscribe(results => {
        this.coaches = results.sort(dynamicSort('fullName')).filter(x => x.status == ClientStatus.Active || x.id == this.selectedValue);
        this.coachData = this.coaches;
      });
  }

    handleFilter(value: any) {
      if (value.length >= 1) {
        this.coachData = this.coaches.filter(x => x.fullName.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    } else {
        this.coachData = this.coaches;
        this.combo.toggle(false);
    }
  }
}
